export const groupTags = (tags) => {
    if (!tags || !Array.isArray(tags)) return {};

    return tags.reduce((acc, curr) => {
        const { type } = curr;
        if (!acc.hasOwnProperty(type)) {
            acc[type] = [];
        }
        acc[type].push(curr);
        return acc;
    }, {});
};
